module.exports = __webpack_public_path__ + "img/PL00184.b1323efc.png";